import React from "react";
import { useT } from "../i18n/LanguageContext";
import { SectionTag } from "../components/Section";
import { PDF } from "../i18n/photos";
import {
  Landmark, Vote, Wifi, Banknote, Mountain, HeartPulse, Tv, Building2,
} from "lucide-react";

const ITEMS = [
  { icon: Landmark, k: "ind.public" },
  { icon: Vote, k: "ind.elections" },
  { icon: Wifi, k: "ind.telecom" },
  { icon: Banknote, k: "ind.banking" },
  { icon: Mountain, k: "ind.mining" },
  { icon: HeartPulse, k: "ind.health" },
  { icon: Tv, k: "ind.media" },
  { icon: Building2, k: "ind.utilities" },
];

export default function IndustriesPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-industries">
      <section className="relative overflow-hidden border-b border-white/10 py-16 md:py-24">
        <img src={PDF.peopleDesks} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-bg/70 via-brand-bg/90 to-brand-bg" />
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("industries.tag")}</SectionTag>
          <h1 className="mt-6 max-w-3xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("industries.title")}
          </h1>
          <p className="mt-6 max-w-2xl text-base text-brand-textDim">{t("industries.sub")}</p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
            {ITEMS.map(({ icon: Icon, k }, i) => (
              <article key={k} className="group relative flex h-72 flex-col justify-between bg-brand-bg p-6 transition-colors hover:bg-[#0E0E0E]">
                <span className="font-mono text-[10px] tracking-[0.25em] text-brand-textDim">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <Icon className="h-7 w-7 text-white/70 transition-colors group-hover:text-brand-red" strokeWidth={1.4} />
                  <h3 className="mt-6 font-heading text-2xl tracking-tight text-white">{t(k)}</h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Photo strip */}
      <section className="relative h-[40vh] min-h-[300px] overflow-hidden border-t border-white/10">
        <img src={PDF.serverRoomCams} alt="" className="absolute inset-0 h-full w-full object-cover opacity-55" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-black/50 to-transparent" />
      </section>
    </main>
  );
}
